module.exports = __webpack_public_path__ + "static/media/layout7-vid.46f77bd7.svg";